(function () {
  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value || "";
  }

  function renderTags(root, detailsRaw) {
    var container = root.querySelector("[data-rvrn-order-details]");
    if (!container) return;
    container.innerHTML = "";
    if (!detailsRaw) return;
    var items = detailsRaw.split("|").map(function (s) { return s.trim(); }).filter(Boolean);
    items.forEach(function (item) {
      var span = document.createElement("span");
      span.textContent = item;
      container.appendChild(span);
    });
  }

  function initOrderJourney(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-rvrn-order-step]"));
    var progress = root.querySelector("[data-rvrn-order-progress]");
    if (!steps.length) return;

    function activate(step) {
      var index = steps.indexOf(step);
      root.classList.add("is-changing");
      steps.forEach(function (item) {
        item.classList.toggle("is-active", item === step);
      });

      var countEl = root.querySelector("[data-rvrn-order-count]");
      if (countEl) {
        var span = countEl.querySelector("span");
        var em = countEl.querySelector("em");
        if (span) span.textContent = String(index + 1).padStart(2, "0");
        if (em) em.textContent = " / " + String(steps.length).padStart(2, "0");
      }

      setText(root, "[data-rvrn-order-role]", step.getAttribute("data-role"));
      setText(root, "[data-rvrn-order-title]", step.getAttribute("data-title"));
      setText(root, "[data-rvrn-order-copy]", step.getAttribute("data-copy"));
      setText(root, "[data-rvrn-order-footnote]", step.getAttribute("data-foot"));
      renderTags(root, step.getAttribute("data-details"));

      if (progress) progress.style.width = (((index + 1) / steps.length) * 100) + "%";

      window.setTimeout(function () {
        root.classList.remove("is-changing");
      }, 260);
    }

    steps.forEach(function (step) {
      step.addEventListener("click", function () {
        activate(step);
      });
      step.addEventListener("mouseenter", function () {
        activate(step);
      });
      step.addEventListener("focus", function () {
        activate(step);
      });
    });

    activate(steps[0]);
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-rvrn-order-journey]").forEach(initOrderJourney);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
